export default __webpack_public_path__ + "27d979976af2851e756cbf78adb3fdbb.png";